/** @jsx jsx */

import React from 'react';
import { css as _css, cx, keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';

const { lPink, lGrey0, lGrey1, lGrey2, lTeal0 } = colors;
const lineWeight = 5;

const dualRingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dualRing = (size, color) => _css`
  {
    display: inline-block;
    width: ${size}px;
    height: ${size}px;
    animation: 1.2s linear infinite;
  }
  &:after {
    content: "";
    display: block;
    width: ${size - lineWeight * 2}px;
    height: ${size - lineWeight * 2}px;
    // margin: 1px;
    border-radius: 50%;
    border: ${lineWeight}px solid ${color};
    border-color: ${color} transparent ${color} transparent;
    animation: ${dualRingAnimation} 1.2s linear infinite;
  }
`;

const LoadingSpinner = ({ size = 46, color = '#cea5f9' }) => (
  <div
    css={css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    `}
  >
    <div
      className={dualRing(size, color)}
      // style={{ transform: 'scale(0.8)', transformOrigin: 'center' }}
    />
  </div>
);

export default LoadingSpinner;
